var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('nav',[_c('ul',[_c('li',[_c('button',{attrs:{"type":"button"},on:{"click":function($event){return _vm.handleLogOut()}}},[_vm._v("ログアウト")])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }